import React from "react";
import PropTypes from "prop-types";

import { Checkbox } from "antd";

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  value: null,
};

function CheckboxGroup(props) {
  return <Checkbox.Group {...props} />;
}

CheckboxGroup.propTypes = propTypes;
CheckboxGroup.defaultProps = defaultProps;

export default CheckboxGroup;
